<div style="background-color: #f7f7f7">
    <div
        *ngIf="breadcrumbs.length > 0"
        class="breadcrumb"
        fxLayout="nowrap"
        fxLayoutGap="7px"
        fxLayoutAlign.xs="center center"
        ngClass.xs="breadcrumn-mob"
    >
        <a
            class="breadcrumb-text"
            [routerLink]="[breadcrumb?.link | pageIdFromLink]"
            *ngFor="let breadcrumb of breadcrumbs"
            [queryParams]="breadcrumb.link | queryParamFromLink"
            fxLayout="row"
        >
            <p (click)="processLink(breadcrumb.link)">{{ breadcrumb.text }}</p>
            <span class="seperator"> > </span>
        </a>
    </div>
    <hr
        *ngIf="breadcrumbs.length > 0"
        style="
            border-bottom: 1px solid hsla(0, 0%, 75%, 0.502);
            margin: 0;
            opacity: 0.2;
        "
    />
    <ng-container *ngFor="let item of data?.feed; let i = index">
        <div *ngIf="item?.layoutType === 'footer-subscribe'">
            <div
                fxHide.gt-xs
                ngStyle.xs="padding: 27px 17px;"
                style="padding: 32px 0px"
                fxLayout="column"
                fxLayoutAlign.gt-xs="center center"
                fxLayoutAlign.xs="flex-start"
            >
                <div ngClass.xs="HeaderBoxMobile-subs" class="HeaderBox">
                    <p
                        ngClass.xs="HeaderBox__mobile-title"
                        ngStyle.xs="font-size: 16px;"
                        class="HeaderBox__title"
                        >{{ item?.layoutContent?.title?.text }}</p
                    >
                </div>
                <div fxLayout="row" fxLayoutAlign="center center">
                    <mat-form-field
                        [ngStyle.xs]="{ width: '70%' }"
                        appearance="outline"
                        class="newsletter"
                    >
                        <input
                            type="email"
                            [formControl]="email"
                            placeholder="{{ item?.layoutContent?.placeholder }}"
                            matInput
                            (keyup)="checkValidEmail()"
                        />
                    </mat-form-field>
                    <button
                        mat-flat-button
                        style="width: 108px; margin-left: 8px"
                        class="call-to-action-button newsletter-button"
                        matSuffix
                        (click)="processLink(item?.layoutContent?.button?.link)"
                        >{{ item?.layoutContent?.button?.title?.text }}</button
                    >
                </div>
                <mat-error
                    [style.color]="subscribeColor"
                    style="
                        padding-left: 1em;
                        padding-top: 0.5em;
                        font-size: 14px;
                    "
                    [ngStyle.gt-xs]="{ width: '100%', marginLeft: '65%' }"
                    >{{ subscribeMessage }}</mat-error
                >
            </div>
            <hr
                style="
                    border-bottom: 1px solid hsla(0, 0%, 75%, 0.502);
                    margin: 0;
                    opacity: 0.2;
                "
            />
        </div>
        <div
            ngClass.xs="featuredBox"
            style="background-color: #fff"
            *ngIf="item?.layoutType === 'footer-featured'"
        >
            <div ngStyle.xs="padding: 32px 17px;" style="padding: 48px 0px">
                <div ngClass.xs="HeaderBoxMobile" class="HeaderBox">
                    <p
                        ngClass.xs="HeaderBox__mobile-title"
                        class="HeaderBox__title"
                        >{{ item?.layoutContent?.title?.text }}</p
                    >
                </div>
                <div
                    ngClass.xs="featuredBannerMobile"
                    ngClass.gt-xs="featuredBanner"
                    *ngFor="let banners of item?.layoutContent?.featured"
                >
                    <picture>
                        <img
                            style="width: 100%"
                            src="{{ banners?.image }}"
                            appImageCDN
                        />
                    </picture>
                </div>
                <div fxLayoutAlign.gt-xs="center none">
                    <button
                        (click)="processLink(item?.layoutContent?.button?.link)"
                        style="padding:10px 24px; line-height: normal;
                        font-size: 13px; background-color: {{
                            item?.layoutContent?.button?.background
                        }}; color: {{
                            item?.layoutContent?.button?.title?.color
                        }}"
                        mat-flat-button
                        >{{ item?.layoutContent?.button?.title?.text }}</button
                    >
                </div>
            </div>
            <hr
                style="
                    border-bottom: 1px solid hsla(0, 0%, 75%, 0.502);
                    margin: 0;
                    opacity: 0.2;
                "
            />
        </div>
        <div
            *ngIf="item?.layoutType === 'footer-rating'"
            style="background-color: #fff"
        >
            <div ngStyle.xs="padding: 32px 17px;" style="padding: 48px 0px">
                <div ngClass.xs="HeaderBoxMobile" class="HeaderBox">
                    <p
                        ngClass.xs="HeaderBox__mobile-title"
                        class="HeaderBox__title"
                        >{{ item?.layoutContent?.title?.text }}</p
                    >
                </div>
                <div>
                    <picture>
                        <img
                            style="width: 100%"
                            src="{{ item?.layoutContent?.rating?.image }}"
                            appImageCDN
                        />
                    </picture>
                </div>
            </div>
            <hr
                style="
                    border-bottom: 1px solid hsla(0, 0%, 75%, 0.502);
                    margin: 0;
                    opacity: 0.2;
                "
            />
        </div>
        <div
            *ngIf="item?.layoutType === 'footer-conformance'"
            style="background-color: #fff"
        >
            <div
                fxLayout="row nowrap"
                fxLayoutGap.gt-xs="68px"
                fxLayoutGap="30px"
                fxLayoutAlign="center center"
                fxLayoutAlign.xs="space-between flex-start"
                style="padding: 31px 17px"
                ngStyle.gt-xs="padding: 48px 17px"
            >
                <div *ngFor="let item of item?.layoutContent?.conformance">
                    <div
                        [ngStyle]="{ fontSize: '14px' }"
                        [ngStyle.xs]="{ fontSize: '9px' }"
                        fxFlex
                        fxLayoutAlign="center center"
                        fxLayout.xs="column"
                        fxLayoutGap.xs="10px"
                        fxLayoutGap="20px"
                    >
                        <img
                            [ngStyle]="{ width: '40px', height: '40px' }"
                            [ngStyle.xs]="{ width: '50px', height: '50px' }"
                            src="{{ item?.icon }}"
                            appImageCDN
                        /><span
                            class="conformance-text"
                            [ngStyle]="{ marginLeft: '20px' }"
                            [ngStyle.xs]="{ marginLeft: '10px', width: '100%' }"
                            >{{ item?.text }}</span
                        >
                    </div>
                </div>
            </div>
        </div>
        <div
            *ngIf="item?.layoutType === 'footer-conformance-with-background'"
            style="background-color: #f7f7f7"
        >
            <div
                fxLayout="row nowrap"
                fxLayoutGap.gt-xs="68px"
                fxLayoutGap="30px"
                fxLayoutAlign="center center"
                fxLayoutAlign.xs="space-between flex-start"
                style="padding: 31px 17px"
                ngStyle.gt-xs="padding: 48px 17px"
            >
                <div *ngFor="let item of item?.layoutContent?.conformance">
                    <div
                        [ngStyle]="{ fontSize: '14px' }"
                        [ngStyle.xs]="{ fontSize: '9px' }"
                        fxFlex
                        fxLayoutAlign="center center"
                        fxLayout.xs="column"
                        fxLayoutGap.xs="10px"
                        fxLayoutGap="20px"
                    >
                        <img
                            [ngStyle]="{ width: '40px', height: '40px' }"
                            [ngStyle.xs]="{ width: '50px', height: '50px' }"
                            src="{{ item?.icon }}"
                            appImageCDN
                        /><span
                            class="conformance-text"
                            [ngStyle]="{ marginLeft: '20px' }"
                            [ngStyle.xs]="{ marginLeft: '10px', width: '100%' }"
                            >{{ item?.text }}</span
                        >
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="item?.layoutType === 'footer-paymentOptions'">
            <div
                fxLayout="column"
                fxLayout.xs="row wrap"
                fxLayoutAlign.gt-xs="center center"
                [ngStyle.gt-xs]="{ margin: '35px 0' }"
                [ngStyle.xs]="{ marginLeft: '17px' }"
            >
                <div
                    style="margin-bottom: 15px"
                    [ngStyle.xs]="{ margin: '26px 0 20px 0' }"
                >
                    <span
                        class="payment-text"
                        [ngClass.gt-xs]="{ fontSize: '16px' }"
                        [ngStyle.xs]="{ fontSize: '13px' }"
                        >{{ item?.layoutContent?.title?.text }}</span
                    >
                </div>
                <div
                    fxLayout="row"
                    fxLayout.xs="row wrap"
                    fxLayoutGap.gt-xs="16px"
                    fxLayoutGap="15px"
                    [ngStyle.xs]="{ marginBottom: '18px' }"
                >
                    <div
                        *ngFor="
                            let icons of item?.layoutContent?.paymentOptions
                        "
                        fxLayoutAlign="center center"
                    >
                        <picture
                            [ngStyle.gt-xs]="{ width: '82px', margin: '0px' }"
                            [ngStyle.xs]="{ width: '73px' }"
                            style="margin-bottom: 12px"
                        >
                            <img
                                style="width: 100%"
                                src="{{ icons.icon }}"
                                appImageCDN
                            />
                        </picture>
                    </div>
                </div>
            </div>
            <hr [ngStyle.xs]="{ margin: '0px 19px' }" />
        </div>
        <div *ngIf="item?.layoutType === 'footer-static-pages-section'">
            <div
                fxLayout="row"
                fxShow.xs="false"
                fxLayoutAlign="space-between"
                style="min-height: 260px"
                [ngStyle]="{ fontSize: '14px' }"
                [ngStyle.xs]="{ fontSize: '13px' }"
            >
                <div
                    fxLayout="row wrap"
                    fxFlex.gt-xs="0 0 68%"
                    fxLayoutAlign.gt-xs="space-between"
                    [ngStyle.gt-xs]="{ padding: '47px 0 25px 34px' }"
                >
                    <div
                        fxFlex.gt-xs="0 0 33%"
                        fxLayout="column"
                        *ngFor="
                            let staticPages of item?.layoutContent?.staticPages;
                            let i = index
                        "
                    >
                        <div fxShow.gt-xs="true" fxShow.xs="false">
                            <p
                                style="
                                    margin-bottom: 24px;
                                    font-family: 'Roboto Condensed', sans-serif;
                                    font-size: 16px;
                                "
                                >{{ staticPages?.text }}</p
                            >
                            <div
                                *ngFor="let clickable of staticPages?.feed"
                                style="padding-bottom: 15px"
                            >
                                <div
                                    *ngIf="
                                        clickable.link.includes('https://');
                                        else noExternal
                                    "
                                >
                                    <a
                                        href="{{ clickable.link }}"
                                        target="_blank"
                                        style="
                                            line-height: 13px;
                                            font-size: 13px;
                                            color: black;
                                        "
                                        ><span>{{ clickable?.text }}</span>
                                    </a>
                                </div>
                                <ng-template #noExternal>
                                    <a
                                        [routerLink]="[
                                            clickable?.link | pageIdFromLink
                                        ]"
                                        [queryParams]="
                                            clickable.link | queryParamFromLink
                                        "
                                        style="
                                            line-height: 13px;
                                            font-size: 13px;
                                            color: black;
                                        "
                                        ><span>{{ clickable?.text }}</span></a
                                    >
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>
                <hr fxShow.gt-xs="true" />
                <div fxFlex.gt-xs="0 0 32%" fxLayout="column">
                    <div
                        fxFlex.gt-xs="0 0 50%"
                        [ngStyle.gt-xs]="{ padding: '47px 30px 47px 34px' }"
                        fxLayout="column"
                        *ngIf="item?.layoutContent?.followUs"
                    >
                        <span
                            class="footer-page__description__large-text"
                            ngClass.xs="footer-page__description__large-text__mobile-2"
                            >{{
                                item?.layoutContent?.followUs?.title?.text
                            }}</span
                        >
                        <div fxLayout="row" fxLayoutGap="9px">
                            <a
                                rel="noreferrer"
                                target="_blank"
                                href="{{ images?.link }}"
                                *ngFor="
                                    let images of item?.layoutContent?.followUs
                                        ?.iconFeed
                                "
                            >
                                <img
                                    style="
                                        width: 36px;
                                        height: 36px;
                                        cursor: pointer;
                                    "
                                    appImageCDN
                                    src="{{ images?.icon }}"
                                />
                            </a>
                        </div>
                    </div>
                    <hr [ngStyle.xs]="{ margin: '0px 19px' }" />
                    <div
                        fxFlex.gt-xs="0 0 50%"
                        [ngStyle.gt-xs]="{ padding: '47px 30px 47px 34px' }"
                        [ngClass.xs]="{ pad_mobile: 'true' }"
                        *ngIf="item?.layoutContent?.downloadApp"
                        [ngStyle.xs]="{ padding: '27px 15px' }"
                    >
                        <span
                            class="footer-page__description__large-text"
                            ngClass.xs="footer-page__description__large-text__mobile-2"
                        >
                            {{
                                item?.layoutContent?.downloadApp?.title?.text
                            }}</span
                        >
                        <div
                            fxLayout="row"
                            fxLayoutGap.xs="23px"
                            fxLayoutGap.gt-xs="25px"
                            [ngStyle.gt-xs]="{ paddingTop: '12px' }"
                            [ngStyle.xs]="{ marginTop: '16px' }"
                        >
                            <img
                                style="
                                    width: 118px;
                                    height: 38px;
                                    cursor: pointer;
                                "
                                [ngStyle.gt-xs]="{ width: '90', height: '30' }"
                                *ngFor="
                                    let iconable of item?.layoutContent
                                        ?.downloadApp?.iconFeed
                                "
                                (click)="externalLinksRedirect(iconable?.link)"
                                src="{{ iconable?.icon }}"
                                appImageCDN
                                alt=""
                            />
                        </div>
                    </div>
                </div>
            </div>
            <hr fxShow.gt-xs="true" />
        </div>
        <div *ngIf="item?.layoutType === 'footer-static-pages-section-v2'">
            <div
                fxLayout="row"
                fxLayoutAlign="space-between"
                style="min-height: 251px"
                class="padding-div-v2"
            >
                <div
                    fxFlex.gt-xs="0 0 43%"
                    fxLayout="column"
                    [ngStyle.gt-xs]="{ padding: '48px 0' }"
                >
                    <div ngStyle.xs="padding: 27px 17px;" fxLayout="column">
                        <div class="Subscribe-Box">
                            <p class="Subscribe-title">{{
                                item?.layoutContent?.subscribe?.title?.text
                            }}</p>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="center center">
                            <mat-form-field
                                [ngStyle.gt-xs]="{ width: '100%' }"
                                appearance="outline"
                                class="newsletter"
                            >
                                <input
                                    type="email"
                                    [formControl]="email"
                                    placeholder="{{
                                        item?.layoutContent?.subscribe
                                            ?.placeholder
                                    }}"
                                    matInput
                                    (keyup)="checkValidEmail()"
                                />
                            </mat-form-field>
                            <button
                                mat-flat-button
                                style="width: 140px; margin-left: 8px"
                                class="call-to-action-button newsletter-button"
                                matSuffix
                                (click)="
                                    processLink(
                                        item?.layoutContent?.subscribe?.button
                                            ?.link
                                    )
                                "
                                >{{
                                    item?.layoutContent?.subscribe?.button
                                        ?.title?.text
                                }}</button
                            >
                        </div>
                        <mat-error
                            [style.color]="subscribeColor"
                            style="padding-top: 0.5em; font-size: 14px"
                            [ngStyle.gt-xs]="{ width: '100%' }"
                            >{{ subscribeMessage }}</mat-error
                        >
                    </div>
                </div>
                <div
                    fxLayout="row wrap"
                    fxFlex.gt-xs="0 0 43%"
                    [ngStyle.gt-xs]="{ padding: '48px 0 33px 0px' }"
                    fxLayoutGap="117px"
                >
                    <div
                        fxLayout="column"
                        *ngFor="
                            let staticPages of item?.layoutContent?.staticPages;
                            let i = index
                        "
                    >
                        <div>
                            <p
                                style="
                                    margin-bottom: 24px;
                                    margin-top: 0;
                                    font-family: 'Roboto Condensed', sans-serif;
                                    font-size: 16px;
                                "
                                >{{ staticPages?.text }}</p
                            >
                            <div
                                *ngFor="let clickable of staticPages?.feed"
                                style="padding-bottom: 15px"
                            >
                                <div
                                    *ngIf="
                                        clickable.link.includes('https://');
                                        else noExternal
                                    "
                                >
                                    <a
                                        href="{{ clickable.link }}"
                                        target="_blank"
                                        style="
                                            line-height: 13px;
                                            font-size: 13px;
                                            color: black;
                                        "
                                        ><span>{{ clickable?.text }}</span>
                                    </a>
                                </div>
                                <ng-template #noExternal>
                                    <a
                                        [routerLink]="[
                                            clickable?.link | pageIdFromLink
                                        ]"
                                        [queryParams]="
                                            clickable.link | queryParamFromLink
                                        "
                                        style="
                                            line-height: 13px;
                                            font-size: 13px;
                                            color: black;
                                        "
                                        ><span>{{ clickable?.text }}</span></a
                                    >
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr fxShow.gt-xs="true" />
        </div>

        <div *ngIf="item?.layoutType === 'footer-listing'" fxLayout="column">
            <div fxShow.gt-xs="true" fxShow="false">
                <div *ngFor="let listings of item.layoutContent?.listing">
                    <div class="padding-div">
                        <p
                            style="margin-bottom: 24px; font-size: 16px"
                            class="footer-page__description__large-text"
                        >
                            {{ listings?.title?.text }}
                        </p>
                        <div [ngStyle]="{ display: 'block' }">
                            <div
                                fxLayout.xs="column"
                                *ngFor="
                                    let item of listings?.feed;
                                    let i = index
                                "
                                style="margin-bottom: 9px"
                                [ngStyle.xs]="{
                                    paddingTop: '0',
                                    height: 'fit-content'
                                }"
                                [ngStyle.gt-xs]="{
                                    flex:
                                        i === listings?.feed.length - 1
                                            ? '1 0 33%'
                                            : '0 0 33%'
                                }"
                            >
                                <span
                                    class="footer-page__description__text"
                                    style="
                                        font-size: 13px;
                                        font-family: 'Roboto Condensed',
                                            sans-serif;
                                    "
                                >
                                    {{ item?.subtitle?.text }}
                                </span>
                                <div
                                    fxLayout="row wrap"
                                    style="line-height: 20px"
                                    fxLayoutAlign.xs="space-between"
                                    [ngStyle.xs]="{ marginTop: '16px' }"
                                    [ngStyle.gt-xs]="{
                                        marginTop: '16px',
                                        width: '100%',
                                        'max-height': '40vh',
                                        fontSize: '9px'
                                    }"
                                >
                                    <a
                                        fxFlex.gt-xs="0 0 180px"
                                        fxFlex.xs="0 0 45%"
                                        *ngFor="
                                            let clickable of item?.feed;
                                            let j = index;
                                            last as last
                                        "
                                        [routerLink]="[
                                            clickable?.link | pageIdFromLink
                                        ]"
                                        [queryParams]="
                                            clickable?.link | queryParamFromLink
                                        "
                                        fxLayoutAlign="space-between center"
                                        [ngStyle.xs]="{ marginRight: '0' }"
                                        style="
                                            color: black;
                                            margin-right: 20px;
                                            padding-bottom: 15px;
                                        "
                                    >
                                        <span
                                            [ngStyle.xs]="{
                                                fontSize: '12px',
                                                ' white-space': 'nowrap',
                                                overflow: 'hidden',
                                                'text-overflow': 'ellipsis',
                                                width: '100%',
                                                lineHeight: '13px'
                                            }"
                                            class="
                                                footer-page__description__small-text
                                            "
                                        >
                                            {{ clickable?.text }}
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                </div>
            </div>
        </div>

        <div
            fxLayout="row"
            fxShow.xs="true"
            fxShow.gt-xs="false"
            fxLayout.xs="column-reverse"
            fxLayoutAlign="space-between"
            *ngIf="item?.layoutType === 'footer-static-pages'"
            [ngStyle.xs]="{ fontSize: '13px' }"
        >
            <div fxLayout="row wrap" fxLayout.xs="column">
                <div
                    fxLayout="column"
                    *ngFor="
                        let staticPages of item?.layoutContent?.staticPages;
                        let i = &quot;index+1&quot;
                    "
                >
                    <mat-accordion fxShow.xs="true" fxShow.gt-xs="false">
                        <mat-expansion-panel
                            (opened)="setAccordionState(i)"
                            [expanded]="isBot || openAccordionIndex === i"
                            style="box-shadow: none; background-color: #f7f7f7"
                        >
                            <mat-expansion-panel-header
                                [ngStyle.xs]="{
                                    margin: '14px 17px',
                                    padding: '0'
                                }"
                            >
                                <mat-panel-title>
                                    <span
                                        style="
                                            font-family: 'Roboto Condensed',
                                                sans-serif;
                                            font-size: 16px;
                                        "
                                        >{{ staticPages?.text }}</span
                                    >
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div
                                *ngFor="let clickable of staticPages?.feed"
                                style="padding: 0 17px 16px 17px"
                            >
                                <div
                                    *ngIf="
                                        clickable.link.includes('https://');
                                        else noExternalMobile
                                    "
                                >
                                    <a
                                        href="{{ clickable.link }}"
                                        target="_blank"
                                        style="
                                            line-height: 13px;
                                            font-size: 13px;
                                            color: black;
                                        "
                                    >
                                        {{ clickable?.text }}
                                    </a>
                                </div>
                                <ng-template #noExternalMobile>
                                    <a
                                        (click)="
                                            clickable.link.includes('https://')
                                                ? externalLinksRedirect(
                                                      clickable.link
                                                  )
                                                : ''
                                        "
                                        [routerLink]="[
                                            clickable?.link | pageIdFromLink
                                        ]"
                                        [queryParams]="
                                            clickable.link | queryParamFromLink
                                        "
                                        style="
                                            line-height: 13px;
                                            font-size: 13px;
                                            color: black;
                                        "
                                        ><span>{{ clickable?.text }}</span></a
                                    >
                                </ng-template>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                    <hr fxShow="true" fxShow.gt-xs="false" />
                </div>
            </div>
        </div>
        <div
            *ngIf="item?.layoutType === 'footer-followUs'"
            fxShow.xs="true"
            fxShow.gt-xs="false"
        >
            <div
                fxFlex.gt-xs="0 0 50%"
                [ngStyle.gt-xs]="{ padding: '47px 30px 47px 34px' }"
                [ngClass.xs]="{ pad_mobile: 'true' }"
                [ngStyle.xs]="{ padding: '48px 15px 32px 15px' }"
                fxLayout="column"
            >
                <span
                    [ngStyle.xs]="{ marginBottom: '16px' }"
                    class="footer-page__description__large-text"
                    ngClass.xs="footer-page__description__large-text__mobile-2"
                    >{{ item?.layoutContent?.followUs?.title?.text }}</span
                >
                <div fxLayout="row" fxLayoutGap="32px">
                    <a
                        rel="noreferrer"
                        target="_blank"
                        href="{{ images?.link }}"
                        *ngFor="
                            let images of item?.layoutContent?.followUs
                                ?.iconFeed
                        "
                    >
                        <img
                            style="width: 25px; height: 25px; cursor: pointer"
                            appImageCDN
                            src="{{ images?.icon }}"
                        />
                    </a>
                </div>
            </div>
        </div>
        <div
            *ngIf="item?.layoutType === 'footer-downloadApp'"
            fxShow.xs="true"
            fxShow.gt-xs="false"
        >
            <div
                fxFlex.gt-xs="0 0 50%"
                [ngClass.xs]="{ pad_mobile: 'true' }"
                *ngIf="item?.layoutContent?.downloadApp"
                [ngStyle.xs]="{ padding: '0px 15px 48px 15px' }"
            >
                <span
                    class="footer-page__description__large-text"
                    ngClass.xs="footer-page__description__large-text__mobile-2"
                >
                    {{ item?.layoutContent?.downloadApp?.title?.text }}</span
                >
                <div
                    fxLayout="row"
                    fxLayoutGap.xs="23px"
                    fxLayoutGap.gt-xs="25px"
                    [ngStyle.gt-xs]="{ paddingTop: '12px' }"
                    [ngStyle.xs]="{ marginTop: '16px' }"
                >
                    <img
                        style="width: 101px; height: 33px; cursor: pointer"
                        *ngFor="
                            let iconable of item?.layoutContent?.downloadApp
                                ?.iconFeed
                        "
                        (click)="externalLinksRedirect(iconable?.link)"
                        src="{{ iconable?.icon }}"
                        appImageCDN
                        alt=""
                    />
                </div>
            </div>
        </div>
        <div
            fxShow.gt-xs="true"
            fxShow.xs="true"
            *ngIf="item?.layoutType === 'footer-listing-fold'"
        >
            <div
                fxLayout="column"
                *ngFor="
                    let listings of item?.layoutContent?.listing;
                    let j = &quot;index+1&quot;
                "
            >
                <mat-accordion fxShow.xs="true" fxShow.gt-xs="true">
                    <mat-expansion-panel
                        (opened)="setAccordionState(-j)"
                        [expanded]="isBot || openAccordionIndex === -j"
                        style="box-shadow: none; background-color: #f7f7f7"
                    >
                        <mat-expansion-panel-header
                            [ngStyle.xs]="{ margin: '14px 17px', padding: '0' }"
                            ngStyle.gt-xs="padding:14px 5%;"
                        >
                            <mat-panel-title>
                                <span
                                    style="
                                        font-family: 'Roboto Condensed',
                                            sans-serif;
                                        font-size: 16px;
                                    "
                                >
                                    {{ listings?.title?.text }}
                                </span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div
                            [ngStyle]="{
                                display: 'block',
                                padding: '14px 17px'
                            }"
                            ngStyle.gt-xs="padding:14px 5%;"
                        >
                            <div
                                fxLayout.xs="column"
                                *ngFor="
                                    let item of listings?.feed;
                                    let i = index
                                "
                                style="margin-bottom: 9px"
                                [ngStyle.xs]="{
                                    paddingTop: '0',
                                    height: 'fit-content'
                                }"
                                [ngStyle.gt-xs]="{
                                    flex:
                                        i === listings?.feed?.length - 1
                                            ? '1 0 33%'
                                            : '0 0 33%'
                                }"
                            >
                                <span
                                    class="footer-page__description__text"
                                    style="
                                        font-size: 13px;
                                        font-family: 'Roboto Condensed',
                                            sans-serif;
                                    "
                                >
                                    {{ item?.subtitle?.text }}
                                </span>
                                <div
                                    fxLayout="row wrap"
                                    style="line-height: 20px"
                                    fxLayoutAlign.xs="space-between"
                                    [ngStyle.xs]="{ marginTop: '16px' }"
                                    [ngStyle.gt-xs]="{
                                        marginTop: '15px',
                                        width: '100%',
                                        'max-height': '40vh',
                                        fontSize: '9px'
                                    }"
                                >
                                    <a
                                        fxFlex.gt-xs="0 0 180px"
                                        fxFlex.xs="0 0 45%"
                                        *ngFor="
                                            let clickable of item?.feed;
                                            let j = index;
                                            last as last
                                        "
                                        [routerLink]="[
                                            clickable?.link | pageIdFromLink
                                        ]"
                                        [queryParams]="
                                            clickable?.link | queryParamFromLink
                                        "
                                        fxLayoutAlign="space-between center"
                                        [ngStyle.xs]="{ marginRight: '0' }"
                                        style="
                                            color: black;
                                            margin-right: 20px;
                                            padding-bottom: 15px;
                                        "
                                    >
                                        <span
                                            [ngStyle.xs]="{
                                                fontSize: '12px',
                                                ' white-space': 'nowrap',
                                                overflow: 'hidden',
                                                'text-overflow': 'ellipsis',
                                                width: '100%',
                                                lineHeight: '13px'
                                            }"
                                            class="
                                                footer-page__description__small-text
                                            "
                                        >
                                            {{ clickable?.text }}
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
                <hr />
            </div>
        </div>
        <div
            fxShow.gt-xs="true"
            fxShow.xs="true"
            *ngIf="item?.layoutType === 'footer-listing-blogs'"
        >
            <div
                fxLayout="column"
                *ngFor="
                    let listings of item?.layoutContent?.listing;
                    let e = &quot;index+1&quot;
                "
            >
                <mat-accordion fxShow.xs="true" fxShow.gt-xs="true">
                    <mat-expansion-panel
                        (opened)="setAccordionState(-(e + listinglength))"
                        [expanded]="
                            isBot || openAccordionIndex === -(e + listinglength)
                        "
                        style="box-shadow: none; background-color: #f7f7f7"
                    >
                        <mat-expansion-panel-header
                            [ngStyle.xs]="{ margin: '14px 17px', padding: '0' }"
                            ngStyle.gt-xs="padding:14px 5%;"
                        >
                            <mat-panel-title>
                                <span
                                    style="
                                        font-family: 'Roboto Condensed',
                                            sans-serif;
                                        font-size: 16px;
                                    "
                                >
                                    {{ listings?.title?.text }}
                                </span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div
                            [ngStyle]="{
                                display: 'block',
                                padding: '14px 17px'
                            }"
                            ngStyle.gt-xs="padding:14px 5%;"
                        >
                            <div
                                fxLayout.xs="column"
                                *ngFor="
                                    let item of listings?.feed;
                                    let i = index
                                "
                                style="margin-bottom: 9px"
                                [ngStyle.xs]="{
                                    paddingTop: '0',
                                    height: 'fit-content'
                                }"
                                [ngStyle.gt-xs]="{
                                    flex:
                                        i === listings?.feed?.length - 1
                                            ? '1 0 33%'
                                            : '0 0 33%'
                                }"
                            >
                                <span
                                    class="footer-page__description__text"
                                    style="
                                        font-size: 13px;
                                        font-family: 'Roboto Condensed',
                                            sans-serif;
                                    "
                                >
                                    {{ item?.subtitle?.text }}
                                </span>
                                <div
                                    fxLayout="row wrap"
                                    style="line-height: 20px"
                                    fxLayoutAlign.xs="space-between"
                                    [ngStyle.xs]="{ marginTop: '16px' }"
                                    [ngStyle.gt-xs]="{
                                        marginTop: '15px',
                                        width: '100%',
                                        'max-height': '40vh',
                                        fontSize: '9px'
                                    }"
                                >
                                    <a
                                        fxFlex.gt-xs="0 0 180px"
                                        fxFlex.xs="0 0 45%"
                                        *ngFor="
                                            let clickable of item?.feed;
                                            let j = index;
                                            last as last
                                        "
                                        [routerLink]="[
                                            clickable?.link | pageIdFromLink
                                        ]"
                                        [queryParams]="
                                            clickable?.link | queryParamFromLink
                                        "
                                        target="_blank"
                                        fxLayoutAlign="space-between center"
                                        [ngStyle.xs]="{ marginRight: '0' }"
                                        style="
                                            color: black;
                                            margin-right: 20px;
                                            padding-bottom: 15px;
                                        "
                                    >
                                        <span
                                            [ngStyle.xs]="{
                                                fontSize: '12px',
                                                ' white-space': 'nowrap',
                                                overflow: 'hidden',
                                                'text-overflow': 'ellipsis',
                                                width: '100%',
                                                lineHeight: '13px'
                                            }"
                                            class="
                                                footer-page__description__small-text
                                            "
                                        >
                                            {{ clickable?.text }}
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
                <hr />
            </div>
        </div>
        <div
            *ngIf="item?.layoutType === 'footer-follow-us-and-download-app'"
            fxLayout="row"
            fxLayoutAlign="space-between end"
            ngStyle.gt-xs="padding:48px 5%"
        >
            <a
                [routerLink]="[
                    item?.layoutContent?.logo?.link | pageIdFromLink
                ]"
                [queryParams]="
                    item?.layoutContent?.logo?.link | queryParamFromLink
                "
                aria-label="{item?.link}"
            >
                <picture>
                    <img
                        style="width: 179px"
                        src="{{ item?.layoutContent?.logo?.icon }}"
                        alt=""
                    />
                </picture>
            </a>
            <div fxLayout="row">
                <div
                    fxLayout="column"
                    *ngIf="item?.layoutContent?.followUs"
                    style="margin-right: 80px"
                >
                    <span class="footer-page__description__large-text-v2">{{
                        item?.layoutContent?.followUs?.title?.text
                    }}</span>
                    <div fxLayout="row" fxLayoutGap="16px">
                        <a
                            rel="noreferrer"
                            target="_blank"
                            href="{{ images?.link }}"
                            *ngFor="
                                let images of item?.layoutContent?.followUs
                                    ?.iconFeed
                            "
                        >
                            <img
                                style="
                                    width: 27px;
                                    height: 27px;
                                    cursor: pointer;
                                "
                                appImageCDN
                                src="{{ images?.icon }}"
                            />
                        </a>
                    </div>
                </div>
                <div
                    [ngClass.xs]="{ pad_mobile: 'true' }"
                    *ngIf="item?.layoutContent?.downloadApp"
                    [ngStyle.xs]="{ padding: '27px 15px' }"
                >
                    <span
                        class="footer-page__description__large-text-v2"
                        style="margin-bottom: 17px"
                    >
                        {{
                            item?.layoutContent?.downloadApp?.title?.text
                        }}</span
                    >
                    <div
                        fxLayout="row"
                        fxLayoutGap.xs="23px"
                        fxLayoutGap.gt-xs="25px"
                        style="margin-top: 17px"
                    >
                        <img
                            style="width: 118px; height: 38px; cursor: pointer"
                            [ngStyle.gt-xs]="{ width: '90', height: '30' }"
                            *ngFor="
                                let iconable of item?.layoutContent?.downloadApp
                                    ?.iconFeed
                            "
                            (click)="externalLinksRedirect(iconable?.link)"
                            src="{{ iconable?.icon }}"
                            appImageCDN
                            alt=""
                        />
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <div
        class="padding-div"
        [ngStyle.gt-xs]="{
            textAlign: 'left',
            backgroundColor: data?.bottomBar?.color,
            color: data?.bottomBar?.title?.color,
            padding: '34px 5%'
        }"
        [ngStyle.xs]="{
            textAlign: 'left',
            backgroundColor: data?.bottomBar?.color,
            color: data?.bottomBar?.title?.color,
            padding: '32px 16px',
            marginBottom: page === 'dp' ? '5rem' : '0'
        }"
    >
        <div
            fxLayout="row"
            fxLayout.xs="column"
            fxLayoutAlign.gt-xs="space-between"
        >
            <p style="font-size: 13px" ngStyle.xs="margin:0 0 10px 0">
                {{ data?.bottomBar?.title?.text }}
            </p>
            <div fxLayout="row" fxLayoutAlign.gt-xs="center center">
                <div
                    fxLayout
                    fxLayoutAlign="center center"
                    *ngFor="
                        let item of data?.bottomBar?.helpDesk;
                        let isLast = last
                    "
                >
                    <a
                        [routerLink]="[item?.link | pageIdFromLink]"
                        [queryParams]="item?.link | queryParamFromLink"
                        aria-label="{item?.link}"
                        [ngStyle]="{
                            color: data?.bottomBar?.title?.color
                        }"
                    >
                        <p
                            class="bottom-bar-text"
                            ngStyle.xs="font-size:10px"
                            >{{ item?.text }}</p
                        >
                    </a>
                    <span *ngIf="!isLast" style="margin: 0 8px">|</span>
                </div>
            </div>
        </div>
    </div>
</div>
